var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.9c74002fa7f7d16313734a18d20e98b2.svg#D';
                    var viewUrl = 'sprites.9c74002fa7f7d16313734a18d20e98b2.svg#view-D';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 42 28',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };